import request from '@/utils/request'


// 查询系统页面列表
export function listMsgSystemPages(query) {
  return request({
    url: '/msg/msg/system/pages/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询系统页面分页
export function pageMsgSystemPages(query) {
  return request({
    url: '/msg/msg/system/pages/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询系统页面详细
export function getMsgSystemPages(data) {
  return request({
    url: '/msg/msg/system/pages/detail',
    method: 'get',
    params: data
  })
}

// 新增系统页面
export function addMsgSystemPages(data) {
  return request({
    url: '/msg/msg/system/pages/add',
    method: 'post',
    data: data
  })
}

// 修改系统页面
export function updateMsgSystemPages(data) {
  return request({
    url: '/msg/msg/system/pages/edit',
    method: 'post',
    data: data
  })
}

// 删除系统页面
export function delMsgSystemPages(data) {
  return request({
    url: '/msg/msg/system/pages/delete',
    method: 'post',
    data: data
  })
}
